import { Copy } from "@phosphor-icons/react";

export default function CopyCta({ user, copying, onCopy }) {
  return (
    <div className="mt-12 border border-volt p-8 text-center">
      <h2 className="font-display text-3xl font-black mb-2">LIKE THIS PLAN?</h2>
      <p className="text-muted-foreground mb-6">
        {user ? "Copy it to your account and customize it for your training cycle." : "Create a free account, copy this plan, and build your own FM 7-22 training programs."}
      </p>
      <button onClick={onCopy} disabled={copying} className="bg-volt text-black px-6 py-3 font-display uppercase tracking-widest font-bold hover:bg-white disabled:opacity-50 inline-flex items-center gap-2" data-testid="public-copy-cta">
        <Copy size={18} weight="bold" /> {user ? "Copy to My Plans" : "Sign Up & Copy"}
      </button>
    </div>
  );
}
